import { Link, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';

const Eductor = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();

    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    let response74 = useInvoke("Eductor", "74", {});

    const [eductors, setEductors] = useState([]);

    const [searchTerm, setSearchTerm] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: "model", direction: "asc" });
    const [filteredEductors, setFilteredEductors] = useState([]);


    useEffect(() => {

        //get Eductors
        if (response74.data.payload != undefined) {

            let myData = JSON.parse(response74.data.payload).data;

            let eductorList = [];
            myData.forEach((entry, index) => {
                const shortdate = new Date(entry[4].split(' ')[0]);

                let eductor = {
                    "id": entry[0],
                    "model": entry[3],
                    "suffix": entry[44],
                    "fanModel": entry[17],
                    "horsepower": parseFloat(entry[12]).toFixed(1),
                    "inletDiameter": parseFloat(entry[10]).toFixed(3),
                    "outletDiameter": parseFloat(entry[11]).toFixed(3),
                    "jobNumber": entry[1],
                    "quoteNumber": entry[2],
                    "customer": entry[38],
                    "dateEntered": shortdate,
                    "emptyFields": parseFloat(entry[45]),
                    "completeness": 44 - parseFloat(entry[45]),
                };

                eductorList.push(eductor);
            });

            eductorList.sort((a, b) => {
                if (a.model < b.model) return -1;
                if (a.model > b.model) return 1;
                return 0;
            });

            setEductors(eductorList);
            setFilteredEductors(eductorList); // initialize filtered data

        }

    }, [response74.data.payload]);

    useEffect(() => {
        let filtered = eductors.filter(e =>
            Object.values(e).some(val =>
                val && val.toString().toLowerCase().includes(searchTerm.toLowerCase())
            )
        );

        if (sortConfig.key) {
            filtered.sort((a, b) => {
                const valA = a[sortConfig.key];
                const valB = b[sortConfig.key];

                if (!isNaN(valA) && !isNaN(valB)) {
                    return sortConfig.direction === "asc" ? valA - valB : valB - valA;
                }

                return sortConfig.direction === "asc"
                    ? valA.toString().localeCompare(valB.toString())
                    : valB.toString().localeCompare(valA.toString());
            });
        }

        setFilteredEductors(filtered);
    }, [searchTerm, sortConfig, eductors]);

    const handleSort = (key) => {
        setSortConfig(prev => ({
            key,
            direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc"
        }));
    };



    document.title = "Eductors";
    return (
        <div className="eductors">
            {user["email"] != undefined &&
                <>
                    {/* return to top */}
                    {/* <button className="btn btn-outline-secondary no-print" style={{ position: "fixed", bottom: "8px", right: "8px", zIndex: 1000, opacity: "0.75" }} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                        <i className="fa fa-arrow-up"></i> Return to Top
                    </button> */}

                    <div className="" style={{ margin: "1%" }}>
                        <h2>Eductor Units</h2>

                        <div style={{ display: "flex", justifyContent: "space-between", margin: "16px 0" }}>

                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                <input
                                    type="text"
                                    placeholder="Search Eductors..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="form-control"
                                    style={{ minWidth: "360px", marginRight: "8px" }}
                                />
                                <button className="btn btn-secondary" style={{ color: "var(--bs-light)" }} onClick={() => setSearchTerm("")}>Clear</button>
                            </div>

                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                <p><Link className="btn btn-primary" to="/Eductor/New">New Eductor</Link></p>
                                <p style={{ marginLeft: "8px" }}><Link className="btn btn-secondary" to="/Eductor/Blank">Blank Eductor Test Form</Link></p>
                            </div>
                        </div>

                        {/* results */}
                        <div className="text-muted no-print" style={{ width: "100%", textAlign: "center", padding: "0px 8px", fontSize: "14px", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                            <span>{filteredEductors.length} {filteredEductors.length === 1 ? "eductor" : "eductors"} found</span>
                            <span>
                                Sorted by <b>{sortConfig.key ? sortConfig.key.charAt(0).toUpperCase() + sortConfig.key.slice(1) : "Default"}</b>, {sortConfig.direction === "asc" ? "A-Z" : "Z-A"}
                            </span>
                        </div>

                        <table className="table table-striped table-bordered table-hover" style={{ margin: "0%", width: "100%" }}>
                            <thead>
                                <tr>
                                    {/* <th style={{ position: "sticky", top: "0", zIndex: "999", textAlign: "left", cursor: "pointer" }}></th> */}
                                    <th style={{ position: "sticky", top: "0", zIndex: "999", textAlign: "left", cursor: "pointer" }} onClick={() => handleSort("model")}>Eductor Model</th>
                                    <th style={{ position: "sticky", top: "0", zIndex: "999", textAlign: "left", cursor: "pointer" }} onClick={() => handleSort("suffix")}>Model (Ext.)</th>
                                    <th style={{ position: "sticky", top: "0", zIndex: "999", textAlign: "left", cursor: "pointer" }} onClick={() => handleSort("fanModel")}>Fan Model</th>
                                    <th style={{ position: "sticky", top: "0", zIndex: "999", textAlign: "center", cursor: "pointer" }} onClick={() => handleSort("horsepower")}>Horsepower</th>
                                    <th style={{ position: "sticky", top: "0", zIndex: "999", textAlign: "center", cursor: "pointer" }} onClick={() => handleSort("inletDiameter")}>Inlet</th>
                                    <th style={{ position: "sticky", top: "0", zIndex: "999", textAlign: "center", cursor: "pointer" }} onClick={() => handleSort("outletDiameter")}>Outlet</th>
                                    <th style={{ position: "sticky", top: "0", zIndex: "999", textAlign: "center", cursor: "pointer" }} onClick={() => handleSort("jobNumber")}>Job Number</th>
                                    <th style={{ position: "sticky", top: "0", zIndex: "999", textAlign: "center", verticalAlign: "middle" }} onClick={() => handleSort("quoteNumber")}>Quote Number</th>
                                    <th style={{ position: "sticky", top: "0", zIndex: "999", textAlign: "center", verticalAlign: "middle" }} onClick={() => handleSort("customer")}>Customer</th>
                                    <th style={{ position: "sticky", top: "0", zIndex: "999", textAlign: "center", verticalAlign: "middle" }} onClick={() => handleSort("dateEntered")}>Date Entered</th>
                                    <th style={{ position: "sticky", top: "0", zIndex: "999", textAlign: "center", verticalAlign: "middle" }} onClick={() => handleSort("completeness")}>Completeness</th>
                                    <th style={{ position: "sticky", top: "0", zIndex: "999", textAlign: "center", verticalAlign: "middle" }} onClick={() => handleSort("id")}>ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredEductors.map((eductor, index) => (

                                    <tr key={index}>
                                        {/* <td style={{ textAlign: "left", verticalAlign: "middle", opacity: "0.5" }}>{index + 1}</td> */}
                                        <td style={{ textAlign: "left", verticalAlign: "middle", whiteSpace: "nowrap" }}>
                                            <Link to={`/Eductor/Details/${eductor.id}`}>{eductor.model}</Link>
                                        </td>
                                        <td style={{ textAlign: "left", verticalAlign: "middle" }}>{eductor.suffix}</td>
                                        <td style={{ textAlign: "left", verticalAlign: "middle" }}>{eductor.fanModel}</td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{parseFloat(eductor.horsepower)}</td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{parseFloat(eductor.inletDiameter).toFixed(2)}</td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{parseFloat(eductor.outletDiameter).toFixed(2)}</td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{eductor.jobNumber}</td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle", whiteSpace: "nowrap" }}>{eductor.quoteNumber}</td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{eductor.customer}</td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{eductor.dateEntered.toLocaleDateString()}</td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                            <div className="progress" style={{ height: "20px", position: "relative", borderRadius: "16px", margin: "auto" }}>

                                                {/* Full bar (representing 44) */}
                                                <div className="progress-bar progress-bar-striped bg-secondary" role="progressbar"
                                                    style={{ width: "100%", height: "100%" }}
                                                    aria-valuenow={100} aria-valuemin="0" aria-valuemax="100">
                                                </div>

                                                {/* Overlay for completeness */}
                                                <div className="progress-bar progress-bar-striped progress-bar-animated bg-teal" role="progressbar"
                                                    style={{
                                                        width: `${(eductor.completeness / 44 * 100).toFixed(2)}%`,
                                                        position: "absolute",
                                                        left: 0,
                                                        height: "100%"
                                                    }}
                                                    aria-valuenow={(eductor.completeness / 44 * 100).toFixed(2)} aria-valuemin="0" aria-valuemax="100">
                                                </div>

                                                {/* Overlayed Percentage Text */}
                                                <span style={{
                                                    position: "absolute",
                                                    width: "100%",
                                                    textAlign: "center",
                                                    fontWeight: "bold",
                                                    fontSize: "14px",
                                                    color: "white",
                                                }}>
                                                    {eductor.completeness} / 44
                                                </span>
                                            </div>
                                        </td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{eductor.id}</td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>


                    </div>
                </>
            }

        </div >
    );
}

export default Eductor;